var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-navbar-nav', [_vm._l(_vm.items, function (item, index) {
    return [!(item !== null && item !== void 0 && item.checkLogin) || _vm.userLogin ? _c('b-nav-item', {
      key: index,
      staticClass: "funko-nav-item",
      attrs: {
        "href": item === null || item === void 0 ? void 0 : item.NavbarHref
      }
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : item.NavbarItem) + " ")]) : _vm._e()];
  }), _vm.isAdmin ? _c('b-nav-item', {
    staticClass: "funko-nav-item",
    attrs: {
      "href": "/administracion"
    }
  }, [_vm._v(" ADMINISTRACIÓN ")]) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }